const PREFERENCES_KEY = 'preferences';

const makeCountriesQueryKey = () => [PREFERENCES_KEY, 'countries'];
const makeMetricsQueryKey = () => [PREFERENCES_KEY, 'metrics'];
const makeSuggestedMetricsQueryKey = () => [PREFERENCES_KEY, 'metrics', 'suggested'];
const makeMetricsLabelsQueryKey = () => [PREFERENCES_KEY, 'metrics', 'labels'];
const makeValuePropQueryKey = () => [PREFERENCES_KEY, 'value-prop'];

export const preferencesQueryKey = {
  countries: makeCountriesQueryKey,
  metrics: makeMetricsQueryKey,
  metricsLabels: makeMetricsLabelsQueryKey,
  suggestedMetrics: makeSuggestedMetricsQueryKey,
  valueProp: makeValuePropQueryKey,
};
